import { FETCH_CONTENT_ERROR, FETCH_CONTENT_REQUEST, FETCH_CONTENT_SUCCESS } from '../constants/ActionTypes';
import { timeout, delay } from '@ynap/promise-utils';
import { Content, ResponseError } from '@ynap/api-utils';

const { getContentByComponent } = Content;

function fetchContentRequest(componentKey) {
    return {
        type: FETCH_CONTENT_REQUEST,
        componentKey,
    };
}

function fetchContentSuccess(content, componentKey) {
    return {
        type: FETCH_CONTENT_SUCCESS,
        payload: content,
        componentKey,
    };
}

function fetchContentError(componentKey) {
    return {
        type: FETCH_CONTENT_ERROR,
        componentKey,
    };
}

export default function fetchContent(componentKey, countryCode, options) {
    return (dispatch, getState) => {
        const state = getState();
        const { country: coreMediaCountry } = state;
        const { country, language, langISO } = state.locale;
        const { brandId } = state.config.global.application;
        const { clientRequest } = state.config.head;
        const { baseUrl, clientId } = state.config.global.services.content;

        const cmCountry = coreMediaCountry?.find((cmCountry) => cmCountry.countryCode === country);
        const coreMediaLocale = cmCountry && cmCountry.languages.hasOwnProperty(language) ? cmCountry.languages[language].locale : langISO;

        dispatch(fetchContentRequest(componentKey));
        const coremediaRequest = getContentByComponent({
            componentKey,
            brandId,
            baseUrl,
            country: countryCode || country,
            language,
            clientId,
            coreMediaLocale,
            options,
        });

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(coremediaRequest), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                if (!res.ok) {
                    throw new ResponseError(res);
                }
                return res.json();
            })
            .then((json) => {
                if (json && !json.errorCode) {
                    return dispatch(fetchContentSuccess(json, componentKey));
                }
                return dispatch(fetchContentError(componentKey));
            })
            .catch((error) => {
                dispatch(fetchContentError(componentKey));
                throw error;
            });
    };
}
